/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Form, Modal, Row, Col, Button, Alert, Spinner } from "react-bootstrap";
import API from "../Utility";

export default function CreateGroupFormModal({ show, onCancel, onSuccess }) {
  // START: Non-Generic Section
  //
  //
  //
  // Form Fields
  const [newGroupName, setNewGroupName] = useState();
  // API Config
  const { project } = useParams(); // project needed for API
  const apiCallConfig = {
    url: `/admin/${project}/groups`,
    data: {
      name: newGroupName ? newGroupName.trim() : newGroupName,
    },
  };
  // Form
  const form = (
    <>
      <Form.Group as={Row} controlId="newGroupNameFormGroup">
        <Col>
          <Form.Label>Name</Form.Label>
          <Form.Control
            required
            maxLength="250"
            type="input"
            name="newGroupGroupNameInput"
            placeholder="Name"
            onChange={(e) => setNewGroupName(e.target.value)}
          />
          <Form.Control.Feedback type="invalid">
            Name is required
          </Form.Control.Feedback>
        </Col>
      </Form.Group>
    </>
  );
  //
  //
  //
  //
  // END: End of Non-Generic Section

  const [submitError, setSubmitError] = useState();
  const [submitting, setSubmitting] = useState();
  const [formValidated, setFormValidated] = useState(false);

  const onSubmit = (e) => {
    const isValid = e.target.checkValidity();
    const apiCallAsync = async () => {
      try {
        setSubmitting(true);
        const apiCallRes = await API.post(apiCallConfig);
        setSubmitting(false);
        onSuccess(apiCallRes);
      } catch (err) {
        setSubmitting(false);
        if (!err.response) {
          setSubmitError(err && err.message);
        } else {
          setSubmitError(
            err &&
            err.response &&
            err.response.data &&
            err.response.data.message
          );
        }
      }
    };
    setFormValidated(true);
    e.preventDefault();
    e.stopPropagation();
    if (isValid) {
      apiCallAsync();
    }
  };

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      scrollable
      show={show}
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">New Group</Modal.Title>
      </Modal.Header>
      <Form noValidate validated={formValidated} onSubmit={onSubmit}>
        <Modal.Body>
          {form}
          {submitError && <Alert variant="danger">Error: {submitError}</Alert>}
        </Modal.Body>
        <Modal.Footer>
          {!submitting ? (
            <>
              <Button onClick={onCancel} variant="outline-secondary">
                Cancel
              </Button>
              <Button variant="outline-primary" type="submit">
                Save
              </Button>
            </>
          ) : (
            <Spinner animation="border" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          )}
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
